import React, { Suspense, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Route, Switch, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

import { Page } from '@navigation';
import { FloatingWhatsApp, Location } from '@components';
import { history } from '@store/store';
import { fetchConfig } from '@services/config-service';
import { AppLoader } from '@components/AppLoader';
import { setConfig } from '@store/config/actions';
import { useDispatch } from 'react-redux';

/**
 * Router Component create routes from configuration list
 *
 * @component
 * @param {Object} params - Component params
 * @param {Object} params.routes - routes list configuration
 * @param {string} [params.publicPath = "/"] - public path or root path
 * @param {string} [params.notFoundPath = "/login"] - not found path
 * @example
 * const publicPath = "/";
 * const notFoundPath = "/login";
 * const routes = [
 *  {
 *    name: "PATH_CHILDREN",
 *    path: "/children",
 *    showOnNav: false,
 *    component: <div id="unique" />,
 *    parent: {
 *        name: "PATH",
 *        path: "/parent",
 *        showOnNav: false,
 *        component: <div id="unique" />,
 *    },
 *  },
 * ];
 * return (
 *  <Router routes={routes} notFoundPath={notFoundPath} publicPath={publicPath}/>
 * )
 */
const Router = ({ routes, publicPath, notFoundPath }) => {
  // TODO: Mover esto porfa
  const dispatch = useDispatch();
  const [showWhataspp, setShowWhataspp] = useState(null);
  useLayoutEffect(() => {
    fetchConfig().then((response) => {
      setShowWhataspp(response.help.whatsappNumber);
      return dispatch(setConfig(response));
    });
  }, [dispatch]);

  return (
    <Suspense fallback={<AppLoader />}>
      <ConnectedRouter history={history} basename={publicPath}>
        {showWhataspp && <FloatingWhatsApp />}
        <Location />
        <Switch>
          {routes.map((route) => (
            <Route
              exact
              key={route.path}
              path={route.path}
              // eslint-disable-next-line react/jsx-props-no-spreading
              render={(props) => <Page route={route} {...props} />}
            />
          ))}
          <Redirect to={notFoundPath} />
        </Switch>
      </ConnectedRouter>
    </Suspense>
  );
};

Router.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      showOnNav: PropTypes.bool.isRequired,
      component: PropTypes.any.isRequired,
    })
  ).isRequired,
  publicPath: PropTypes.string,
  notFoundPath: PropTypes.string,
};

Router.defaultProps = {
  publicPath: '/',
  notFoundPath: '/login',
};

export default Router;
